import {Injectable} from '@angular/core';
import {HttpClient} from '../../shared/wrappers/HttpClient';
import {Owner} from "../../models/billing-letter/Owner.model";

@Injectable()
export class OwnerService {
    private endPoint: String = "/users";

    constructor(private httpClient: HttpClient) { }

    async getAll(): Promise<Owner[]> {
        var owners = (await this.httpClient.get(this.endPoint, '', 'users')).map(owner => {
            return new Owner(owner);
        });
        return owners;
    }

    async getActiveUsers(): Promise<Owner[]> {
        var owners = await this.httpClient.get(this.endPoint);
        const usersList = new Array<Owner>();
        for (let user of owners) {
            if (user.active === true) {
                usersList.push(user);
            };
        };
        return usersList;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/billing-letter/owner.service.ts